import { Environment } from 'src/app/config/environments';
import { FEATURE_PER_UNIT_BILLING } from 'src/app/featureToggle/constants';
import { adProductFeatureStrategy } from 'src/app/featureToggle/strategies';

import type { FeatureConfig } from '../types';

export const perUnitBillingFeature: FeatureConfig = {
  name: FEATURE_PER_UNIT_BILLING,
  value: {
    [Environment.DEV]: {
      enabled: false,
    },
    [Environment.STAGING]: {
      enabled: false,
    },
    [Environment.PROD]: {
      enabled: false,
    },
  },
  toFeature({ env, productFeatures }) {
    return {
      name: this.name,
      enabled:
        this.value![env].enabled ||
        adProductFeatureStrategy('PerUnitBilling', productFeatures),
    };
  },
};
